module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Archived Issues")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu hidden-md-up"
  }, [_c('label', [_vm._v("Jump to Volume: ")]), _vm._v(" "), _c('b-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    staticClass: "nav mobile-menu",
    attrs: {
      "right": "",
      "is-nav": "",
      "text": _vm.selectedAnchor
    }
  }, _vm._l((_vm.anchorsList), function(item) {
    return _c('b-dropdown-item', {
      key: item.anchor,
      nativeOn: {
        "click": function($event) {
          _vm.selectedAnchor = item.text
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '#' + item.anchor
        }
      }
    }, [_vm._v(_vm._s(item.text))])], 1)
  }))], 1)], 1), _vm._v(" "), _vm._l((_vm.issues), function(item, index) {
    return [_c('div', {
      staticClass: "issue",
      attrs: {
        "id": 'anchor' + item.issue_linkable || ''
      }
    }, [_c('div', {
      staticClass: "hidden-sm-down row"
    }, [_c('div', {
      staticClass: "col-md-3 col-sm-6 col-xs-12 text-center"
    }, [_c('router-link', {
      staticClass: "col",
      attrs: {
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_c('img', {
      staticClass: "issue-cover",
      attrs: {
        "src": item.optimized_urls.small
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('span', {
      staticClass: "text-accent"
    }, [_vm._v("Issue:")]), _vm._v(" Volume " + _vm._s(item.volume) + ", Number " + _vm._s(item.issue) + " | "), _c('span', {
      staticClass: "text-accent"
    }, [_vm._v("Pages:")]), _vm._v(" " + _vm._s(item.pages.start) + " - " + _vm._s(item.pages.end) + "\n            "), _c('a', {
      staticClass: "article-link-item",
      on: {
        "click": function($event) {
          _vm.$root.$emit('show::modal', 'orderReprintModal', item)
        }
      }
    }, [_vm._v("Order a Reprint >")])]), _vm._v(" "), _c('div', {
      staticClass: "text-accent"
    }, [_vm._v("About the Cover")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('router-link', {
      staticClass: "col",
      attrs: {
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_vm._v("Headline Headline Headline...")])], 1), _vm._v(" "), _c('div', {
      staticClass: "caption",
      domProps: {
        "innerHTML": _vm._s(item.caption)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "hidden-md-up row"
    }, [_c('div', {
      staticClass: "col-md-9 col-sm-6 col-xs-12"
    }, [_c('span', {
      staticClass: "text-accent"
    }, [_vm._v("Issue:")]), _vm._v(" Volume " + _vm._s(item.volume) + ", Number " + _vm._s(item.issue) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-accent"
    }, [_vm._v("Pages:")]), _vm._v(" " + _vm._s(item.pages.start) + " - " + _vm._s(item.pages.end) + "\n          "), _c('div', {
      staticClass: "text-accent"
    }, [_vm._v("About the Cover")]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('router-link', {
      staticClass: "col",
      attrs: {
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_vm._v("Headline Headline Headline...")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "my-4 col-sm-6 col-xs-12 text-center"
    }, [_c('router-link', {
      staticClass: "col",
      attrs: {
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_c('img', {
      staticClass: "issue-cover",
      attrs: {
        "src": item.optimized_urls.small
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "caption",
      domProps: {
        "innerHTML": _vm._s(item.caption)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_c('b-button', {
      staticClass: "button-secondary my-2 my-sm-0",
      attrs: {
        "variant": "link",
        "to": {
          name: 'issueDetail',
          params: {
            volumeId: item.volume,
            issueId: item.issue
          }
        }
      }
    }, [_vm._v("\n              View Issue\n            ")]), _c('br'), _vm._v(" "), _c('b-button', {
      staticClass: "button-secondary my-2 my-sm-0",
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function($event) {
          _vm.$root.$emit('show::modal', 'orderReprintModal', item)
        }
      }
    }, [_vm._v("\n              Order a Reprint >\n            ")])], 1)])])])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-758b32ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/ArchivedIssuesPage.vue
// module id = 1453
// module chunks = 1